import { getColor, getMediaDown } from '@atlassiansox/wpl-utils';
import { wplToken } from '@atlassiansox/wpl-token';
import { css } from '@emotion/react';

export const containerStyle = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 32px;
  row-gap: 16px;

  ${getMediaDown('md')} {
    grid-template-columns: 1fr;
  }
`;

export const selectableProductContainerStyle = css`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

export const selectableProductStyle = css`
  display: flex;
  align-items: center;
  border: 1px solid ${getColor('n40')};
  border-radius: 0.25rem;
  padding: ${wplToken('space.150')} ${wplToken('space.150')};
  text-align: left;
  font-size: 1rem;
  font-family: Charlie Display, sans-serif;

  > img {
    margin: 0 5px;
    position: relative;
    top: 1px;
  }
`;

export const nameStyle = css`
  color: ${getColor('n800')};
  font-family: var(--bxp-charlie-text-font-family);
`;
